import { useState, useEffect } from 'react'
import liftChartEventEmitter from './liftChart.eventEmitter'
import liftMonitoringEventEmitter from './liftMonitoring.eventEmitter'
import { useSearchParams } from 'react-router-dom'

export type TTimeSelectionModeType = 'point' | 'range' | 'live'

const useMonitoringModeCtrl = () => {
  const [query] = useSearchParams()
  let queryTs = +query.get('ts') || null
  const [selectedDate, setSelectedDate] = useState(queryTs ? new Date(queryTs) : new Date())
  const [timeSelectionMode, setTimeSelectionMode] = useState<TTimeSelectionModeType>(
    Boolean(queryTs) ? 'point' : 'live'
  )

  const handleTimeSelectionMode = (type: TTimeSelectionModeType) => {
    if (type === 'live') liftMonitoringEventEmitter.next({ state: { live: true, ts: Date.now() } })
    setTimeSelectionMode(type)
  }

  const handleDateSelect = (ts: number) => {
    setSelectedDate(new Date(ts))
    liftMonitoringEventEmitter.next({ state: { live: false, ts } })
  }

  useEffect(() => {
    liftChartEventEmitter.subscribe((event) => {
      if (event.state.live) setTimeSelectionMode('live')
      setSelectedDate(new Date(event.state.ts))
    })
  }, [])

  return {
    handleDateSelect,
    handleTimeSelectionMode,
    selectedDate,
    timeSelectionMode,
  }
}

export default useMonitoringModeCtrl
